module.exports = __webpack_public_path__ + "img/ic_new.2111319b.svg";